import type { TimelineRow } from "./layout";
import { TimelineRowView } from "./Row";

export function TimelineTableBody({
  hasData,
  splitByFunction,
  projectGroups,
  hover,
  onDotEnter,
  onDotLeave,
  onBarClick,
}: {
  hasData: boolean;
  splitByFunction: boolean;
  projectGroups: Array<{ projectName: string; rows: TimelineRow[] }>;
  hover: { dotKey: string } | null;
  onDotEnter: (e: React.MouseEvent<HTMLDivElement>, dotKey: string, lines: string[]) => void;
  onDotLeave: () => void;
  onBarClick: (connectorRunId: number) => void;
}) {
  if (!hasData) {
    return (
      <tbody>
        <tr>
          <td colSpan={splitByFunction ? 4 : 3} className="no-data">
            No runs found in the selected time range
          </td>
        </tr>
      </tbody>
    );
  }
  return (
    <>
      {projectGroups.map(({ projectName, rows }) => (
        <tbody key={projectName}>
          {rows.map((row, idx) => (
            <TimelineRowView
              key={row.id}
              row={row}
              showProjectName={idx === 0}
              onDotEnter={onDotEnter}
              onDotLeave={onDotLeave}
              hoveredDotKey={hover?.dotKey ?? null}
              showFunction={splitByFunction}
              onBarClick={onBarClick}
            />
          ))}
        </tbody>
      ))}
    </>
  );
}
